export enum CompensationType {
  REGULAR_PAY = 'REGULAR_PAY',
  THIRTEENTH_MONTH_PAY = 'THIRTEENTH_MONTH_PAY'
};

export enum RegularPayrollBatch {
  SEMI_MONTHLY = 'SEMI_MONTHLY',
  MONTHLY = 'MONTHLY'
};

export enum ThirteenthMoPayrollBatch {
  ANNUAL = 'ANNUAL'
};